import React from 'react';

const defaultBehaviour = {
    isAllowedTo: () => Promise.resolve(false)
}
const PermissionContext = React.createContext( defaultBehaviour);

export default PermissionContext;